import { Injectable } from "@angular/core";
import { Reserva } from "./reserva";
import { reservas } from "./mock-reserva";
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from "@angular/common/http";
import { environment } from "../environments/environment";
@Injectable({
  providedIn: "root",
})
export class RefundService {
  /** Clave de CMS del error interno (la misma que entrega el backend en el 1102). */
  static readonly INTERNAL_ERROR_CMS_KEY = "error_msg_internal";

  previousRefundRequested: boolean;

  constructor(private http: HttpClient) {}

  showAccountForm: boolean;

  voucherRefund: boolean;
  pnrHasQueueCVOGCX: boolean;
  pnrHasQueueDEVTOT: boolean;
  pnrHasQueueWLLT: boolean;
  isWalletRefund: boolean;
  refundOrigin: string = "Devoluciones";
  pnrHasQueueCVOAFF: boolean;
  hasPercentGC: any;

  isCaravelo: boolean;

  urlIsChileCompra: any;

  isChileCompra: boolean;

  isAAMileRefund: boolean;

  isExcp: boolean;

  refundAAMilesTotal: any;

  headers = new HttpHeaders({
    "Content-Type": "application/json",
    Accept: "application/json",
  });
  showAccountFormM(reserva): boolean {
    if (this.pnrHasQueueWLLTM(reserva)) {
      return true;
    }
    return reserva.body.msg
      ? false
      : reserva.body
          .flatMap((segment) => segment.showAccountForm)
          .some((showAccountForm) => showAccountForm);
  }

  voucherRefundM(reserva): boolean {
    if (this.pnrHasQueueWLLTM(reserva)) {
      return false;
    }
    return reserva.body.msg
      ? true
      : reserva.body
          .flatMap((segment) => segment.voucherRefund)
          .some((voucherRefund) => voucherRefund);
  }

  hasPercentGCM(reserva): any {
    return Array.isArray(reserva.body)
      ? reserva.body
          .flatMap((segment) => segment.hasPercentGC)
          .find((hasPercentGC) => hasPercentGC)
      : false;
  }

  isCaraveloM(reserva): boolean {
    return reserva.body.msg
      ? false
      : reserva.body
          .flatMap((segment) => segment.isCaravelo)
          .some((isCaravelo) => isCaravelo);
  }

  pnrHasQueueCVOGCXM(reserva): boolean {
    return reserva.body.msg
      ? false
      : reserva.body
          .flatMap((segment) => segment.pnrHasQueueCVOGCX)
          .some((pnrHasQueueCVOGCX) => pnrHasQueueCVOGCX);
  }

  pnrHasQueueDEVTOTM(reserva): boolean {
    return reserva.body.msg
      ? false
      : reserva.body
          .flatMap((segment) => segment.pnrHasQueueDEVTOT)
          .some((pnrHasQueueDEVTOT) => pnrHasQueueDEVTOT);
  }

  pnrHasQueueWLLTM(reserva): boolean {
    return reserva.body.msg
      ? false
      : reserva.body
          .flatMap((segment) => [
            segment.pnrHasQueueWLLT,
            segment.isWalletRefund,
            segment.isWallet,
            segment.origen,
            ...(segment.Pax || []).flatMap((pax) => [
              pax.pnrHasQueueWLLT,
              pax.isWalletRefund,
              pax.isWallet,
              pax.origen,
            ]),
          ])
          .some(
            (walletMarker) =>
              walletMarker === true || walletMarker === "Wallet"
          );
  }

  refundOriginM(reserva): string {
    return this.pnrHasQueueWLLTM(reserva) ? "Wallet" : "Devoluciones";
  }

  pnrHasQueueCVOAFFM(reserva): boolean {
    return reserva.body.msg
      ? false
      : reserva.body
          .flatMap((segment) => segment.pnrHasQueueCVOAFF)
          .some((pnrHasQueueCVOAFF) => pnrHasQueueCVOAFF);
  }

  isAAMileRefundM(reserva): boolean {
    return reserva.body.msg
      ? false
      : reserva.body
          .flatMap((segment) => segment.isAAMileRefund)
          .some((isAAMileRefund) => isAAMileRefund);
  }

  isExcpM(reserva): boolean {
    return reserva.body.msg
      ? false
      : reserva.body
          .flatMap((segment) => segment.IsExcp)
          .some((IsExcp) => IsExcp);
  }

  refundAAMilesTotalM(reserva): boolean {
    return reserva.body.msg
      ? false
      : reserva.body
          .flatMap((segment) => segment.refundAAMilesTotal)
          .some((refundAAMilesTotal) => refundAAMilesTotal);
  }

  isChileCompraM(reserva): boolean {
    return reserva.body.msg
      ? false
      : reserva.body
          .flatMap((segment) => segment.isChileCompra)
          .some((isChileCompra) => isChileCompra);
  }

  hasUrlIsChileCompraM(reserva): any {
    return Array.isArray(reserva.body)
      ? reserva.body
          .flatMap((segment) => segment.urlIsChileCompra)
          .find((urlIsChileCompra) => urlIsChileCompra)
      : false;
  }

  previousRefundRequestedM(reserva): boolean {
    return reserva.body.msg
      ? false
      : reserva.body
          .flatMap((segment) => segment.Pax)
          .some(
            (Pax) =>
              !["CREATED", "EMAIL_SENT", "HISTORICS"].includes(Pax.Status)
          );
  }

  getReservas(search: {
    pnr: string;
    Recaptcha?: string;
    redirectToken?: string;
  }): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      /* resolve({ reserva: reservas,
    status: 200 }); */
      this.request(environment.getBookingInfo, JSON.stringify(search)).then(
        (response: HttpResponse<any>) => {
          this.isChileCompra = this.isChileCompraM(response);
          this.isAAMileRefund = this.isAAMileRefundM(response);
          this.isExcp = this.isExcpM(response);
          this.refundAAMilesTotal = this.refundAAMilesTotalM(response);

          this.urlIsChileCompra = this.hasUrlIsChileCompraM(response);
          if (this.urlIsChileCompra) {
            //window.location.href = this.urlIsChileCompra;
            //resolve(null);
          }
          console.log("response", response);
          console.log(
            "refundService this.showAccountFormM(response) :",
            this.showAccountFormM(response)
          );
          console.log(
            "refundService this.voucherRefundM(reserva) :",
            this.voucherRefundM(response)
          );
          this.showAccountForm = this.showAccountFormM(response);
          this.voucherRefund = this.voucherRefundM(response);
          this.hasPercentGC = this.hasPercentGCM(response);
          this.isCaravelo = this.isCaraveloM(response);
          this.pnrHasQueueCVOGCX = this.pnrHasQueueCVOGCXM(response);
          this.pnrHasQueueDEVTOT = this.pnrHasQueueDEVTOTM(response);
          this.pnrHasQueueWLLT = this.pnrHasQueueWLLTM(response);
          this.isWalletRefund = this.pnrHasQueueWLLT;
          this.refundOrigin = this.refundOriginM(response);
          this.pnrHasQueueCVOAFF = this.pnrHasQueueCVOAFFM(response);
          this.previousRefundRequested =
            this.previousRefundRequestedM(response);
          // Las respuestas no-2xx no llegan aquí: las maneja httpErrorResult
          if (response.status === 204) {
            resolve({ reserva: [], status: 204 });
          } else if (response.status === 200 && response.body.msg) {
            resolve({ reserva: response.body, status: 204 });
          } else if (
            response.status === 200 &&
            typeof response.body.msg === "undefined"
          ) {
            resolve({ reserva: response.body, status: 200 });
          } else {
            resolve({ reserva: response.body, status: 999 });
          }
        },
        (err: HttpErrorResponse) => {
          console.log(err);
          const { msg, statusInternalCode, status } = this.httpErrorResult(err);
          resolve({ reserva: { msg, statusInternalCode }, status });
        }
      );
    });
  }
  confirmEmailValidate(request: {
    pnr: string;
    ConfirmToken: string;
  }): Promise<{
    body: { msg: string; msg_stc: string };
    status: number;
  }> {
    return new Promise<any>((resolve, reject) => {
      this.request(
        environment.confirmEmailValidate,
        JSON.stringify({ request })
      ).then(
        (response: HttpResponse<any>) => {
          // tODO: agregar más status codes
          if (response.status === 204) {
            resolve({
              body: `Estimado usuario, no se ha encontrado una reserva asociada con este código.
             Por favor contactárse con nuestro contact center.`,
              status: 204,
            });
          } else if (response.status === 201) {
            resolve({ body: `error`, status: 201 });
          } else {
            resolve({ body: response.body, status: response.status });
          }
        },
        (err: HttpErrorResponse) => {
          console.log(err);
          const { msg, status } = this.httpErrorResult(err);
          resolve({ body: { msg }, status });
        }
      );
    });
  }
  createRefundCase(reserva: Reserva[]): Promise<{
    body: { msg: string; msgEmail: string };
    status: number;
  }> {
    return new Promise<any>((resolve, reject) => {
      this.request(
        environment.createRefundCase,
        JSON.stringify({ reserva })
      ).then(
        (response: HttpResponse<any>) => {
          // tODO: agregar más status codes

          if (response.status === 204) {
            resolve([]);
          } else {
            resolve({ body: response.body, status: response.status });
          }
        },
        (err: HttpErrorResponse) => {
          console.log(err);
          const { msg, status } = this.httpErrorResult(err);
          resolve({ body: { msg }, status });
        }
      );
    });
  }
  // console.log('encrypt ', this.encrypt(pnr));
  // return this.http.post(this.urlGetBookingInfo, JSON.stringify({pnr: pnr}), {headers: this.headers, observe: 'response'}  );

  getAccountType(country: string): Promise<any> {
    country == "Peru" ? (country = "Peru") : country;
    const param = {
      url: environment.getAccountType.url + environment.countryCodes[country],
      method: environment.getAccountType.method,
    };
    return new Promise<any>((resolve, reject) => {
      this.request(param, {}).then(
        (response: HttpResponse<any>) => {
          resolve(response.body);
        },
        (err) => reject(err)
      );
    });
    // return this.http.get(this.urlListBanks, {headers: this.headers});
  }
  listBanks(country: string): Promise<any> {

    if (
      !country ||
      country.trim() === '' ||
      country === 'Selecciona tu País' ||
      !environment.countryCodes?.[country]
    ) {
      console.warn('[listBanks] Country inválido:', country);
      return Promise.resolve([]); // no llamo al backend
    }

    const param = {
      url: environment.listBanks.url + environment.countryCodes[country],
      method: environment.listBanks.method,
    };
    return new Promise<any>((resolve, reject) => {
      this.request(param, {}).then(
        (response: HttpResponse<any>) => {
          resolve(response.body);
        },
        (err) => reject(err)
      );
    });
    // return this.http.get(this.urlListBanks, {headers: this.headers});
  }
  listTypesCol(country: string): Promise<any> {
    const param = {
      url: environment.getTypesCol.url + environment.countryCodes[country],
      method: environment.listBanks.method,
    };
    return new Promise<any>((resolve, reject) => {
      this.request(param, {}).then(
        (response: HttpResponse<any>) => {
          resolve(response.body);
        },
        (err) => reject(err)
      );
    });
  }
  /**
   * Traduce una respuesta no-2xx al mensaje que corresponde según el código HTTP real:
   * - con mensaje del backend (4xx de negocio o 5xx informado): se muestra ese mensaje;
   * - timeout o falla de red (504 / 0): mensaje de timeout;
   * - cualquier otro 5xx: mensaje de error interno.
   */
  private httpErrorResult(err: HttpErrorResponse): {
    msg: string;
    statusInternalCode?: number;
    status: number;
  } {
    const backendMsg = err?.error?.msg;
    if (backendMsg) {
      return { msg: backendMsg, statusInternalCode: err.error.statusInternalCode, status: err.status };
    }
    if (err?.status === 0 || err?.status === 504) {
      return { msg: environment.modalTexts[504], status: 504 };
    }
    // El modal resuelve msg como clave de CMS, por eso no se usa el texto de environment.modalTexts[500]
    // Un status menor a 400 (p. ej. 200 por JSON inválido) se normaliza a 500 para tratarlo como error
    return { msg: RefundService.INTERNAL_ERROR_CMS_KEY, status: err?.status >= 400 ? err.status : 500 };
  }

  private request(
    servicio: { url: string; method: string },
    body?
  ): Promise<HttpResponse<object>> {
    if (!body) {
      body = {};
    }

    return new Promise((resolve, reject) => {
      this.http
        .request(servicio.method, servicio.url, {
          body: body,
          headers: this.headers,
          observe: "response",
          responseType: "json",
        })
        .subscribe(
          (data) => {
            resolve(data);
            // console.log('Respuesta de api ', data);
          },
          (err) => {
            console.log("Error ", err);
            reject(err);
          }
        );
    });
  }
}
